<app-page-wrapper class="bg-login" [state]="pageState">
    <div loaded>
        <div class="login-card bg-blur p-xlg">
            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                <!-- Email -->
                <div class="form-group">
                    <input type="text" formControlName="email" placeholder="Username" />
                    <div
                        *ngIf="loginForm.get('email')?.touched && loginForm.get('email')?.invalid"
                        class="error"
                    >
                        Username is required
                    </div>
                </div>

                <!-- Password -->
                <div class="form-group">
                    <input type="password" formControlName="password" placeholder="Password" />
                    <div
                        *ngIf="
                            loginForm.get('password')?.touched && loginForm.get('password')?.invalid
                        "
                        class="error"
                    >
                        Password must be at least 6 characters
                    </div>
                </div>

                <!-- Button -->
                <div class="mt-md">
                    <button
                        type="submit"
                        [disabled]="loading"
                        class="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#ef4444] hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#ef4444] transition-colors"
                    >
                        {{ loading ? 'Login...' : 'Sign In' }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</app-page-wrapper>
